import { render } from "./MessageComposeDialog.vue?vue&type=template&id=64487e30&scoped=true"
import script from "./MessageComposeDialog.vue?vue&type=script&lang=js"
export * from "./MessageComposeDialog.vue?vue&type=script&lang=js"

import "./MessageComposeDialog.vue?vue&type=style&index=0&id=64487e30&lang=css"
import "./MessageComposeDialog.vue?vue&type=style&index=1&id=64487e30&scoped=true&lang=css"

import exportComponent from "/home/Daten/Entwicklung/repositories/bdl_ui/de.stone.bdl.management.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64487e30"]])

export default __exports__